import { render, staticRenderFns } from "./VouchersTable.vue?vue&type=template&id=6977f5f8"
import script from "./VouchersTable.vue?vue&type=script&lang=js"
export * from "./VouchersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports